import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import university_degrees_transcripts_img1 from "../../assets/images/contents/university-degrees-transcript_1.png"
import university_degrees_transcripts_img2 from "../../assets/images/contents/university-degrees-transcript_2.png"
import university_degrees_transcripts_img3 from "../../assets/images/contents/university-degrees-transcript_3.png"
import { PrimaryButton, SecondaryButton } from '../../components/StyledButtons'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const UniversityDegrees = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
  const modalDiscussionRef = useRef(null);
  const handleOverlayClick = (event) => {
    if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
      setModalDiscussionOpen(false)
    }
  };
  document.onkeydown = function (evt) {
    if (evt.code === 'Escape') {
      setModalDiscussionOpen(false)
    }
  };

  return (
    <div className='university-degrees bg-primary'>
      <div className='color-filter-right' style={{ top: "20%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "52%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-right' style={{ top: "70%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid university-degrees-header pb-100'>
        <div className='container'>

          {language === "en" ?
            <div className='col-sm-12 pt-150'>
              <div className='font-weight-bold text-center font-64 university-degrees-header-title'>University Degrees & Marksheets, Transcripts</div>
              <div className='col-sm-12'>
                <div className='underline-orange'></div>
              </div>
            </div>
            :
            <div className='col-sm-12 pt-150'>
              <div className='font-weight-bold text-center font-64 university-degrees-header-title'>Bằng Đại học & Bảng điểm, Bảng tổng kết</div>
              <div className='col-sm-12'>
                <div className='underline-orange'></div>
              </div>
            </div>
          }
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.university-degrees')} linkToPrevPage="/industries" />
          </div>
        </div>


      </div>
      <div className='university-degrees-content container'>
        <div className='row flex-lg'>
          <div className='col-lg-w-400'>
            <IndustriesStickyMenu educationActive={true} universityDegreesActive={true} />
          </div>
          <div className='col-lg-w--400 university-degrees-content_info'>
            <p className='font-48 font-weight-semibold text-white'>{t('university-degrees-transcripts.title')}</p>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('university-degrees-transcripts.sub-title-1')}</p>
            <p className='text-white pt-20'>{t('university-degrees-transcripts.content-1')}</p>
            <p className='text-white pt-20'>{t('university-degrees-transcripts.content-2')}
            </p>
            <div className='pt-50'>
              <img src={university_degrees_transcripts_img1} alt="" className='img-responsive' />
            </div>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('university-degrees-transcripts.sub-title-2')}</p>
            <p className='text-white pt-20'>{t('university-degrees-transcripts.content-3')}</p>
            <ol className='text-white pt-20'>
              <li>{t('university-degrees-transcripts.content-3-1')}</li>
              <li>{t('university-degrees-transcripts.content-3-2')}</li>
              <li>{t('university-degrees-transcripts.content-3-3')}</li>
              <li>{t('university-degrees-transcripts.content-3-4')}</li>
              <li>{t('university-degrees-transcripts.content-3-5')}</li>
            </ol>
            <p className='text-white pt-20'>{t('university-degrees-transcripts.content-4')}</p>
            <div className='pt-50'>
              <img src={university_degrees_transcripts_img2} alt="" className='img-responsive' />
            </div>
            <div className='pt-50'>
              <img src={university_degrees_transcripts_img3} alt="" className='img-responsive' />
            </div>
            <div className='col-sm-12 pt-30 px-0'>
              <p className='text-white font-weight-medium'>{t('university-degrees-transcripts.content-5')}</p>
              <ul className='list-unstyled pt-20'>
                <li className='checked-line'>{t('university-degrees-transcripts.content-5-1')}</li>
                <li className='checked-line'>{t('university-degrees-transcripts.content-5-2')}</li>
                <li className='checked-line'>{t('university-degrees-transcripts.content-5-3')}</li>
                <li className='checked-line'>{t('university-degrees-transcripts.content-5-4')}</li>
                <li className='checked-line'>{t('university-degrees-transcripts.content-5-5')}</li>
                <li className='checked-line'>{t('university-degrees-transcripts.content-5-6')}</li>
                <li className='checked-line'>{t('university-degrees-transcripts.content-5-7')}</li>
              </ul>
            </div>
            <div className='col-sm-12 pt-30'>
              <div className='row'>
                <SecondaryButton href="/case-study/ashoka">{t('button.download-ashoka-university-case-study')}</SecondaryButton>
              </div>
            </div>
            <div className='col-sm-12 pt-30'>
              <div className='row'>
                <PrimaryButton
                onClick={() => setModalDiscussionOpen(true)}
                >{t('button.schedule-discussion')}</PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <IndustriesImageContainer />
      </div>

      <Footer />
      {modalDiscussionOpen && <ModalContactDiscussionForm
        setOpenModal={setModalDiscussionOpen}
        handleOverlayClick={handleOverlayClick}
        modalRef={modalDiscussionRef} />}
    </div>
  )
}

export default UniversityDegrees